/**
 * Latitude & longitude co-ordinates
 */
export type LatLong = [lat: number, long: number];
